import FormattedMessage from 'I18n/components/FormattedMessage';
import ReenrollmentSelect from 'automation-ui-enrollment/components/ReenrollmentSelect';
import UIList from 'UIComponents/list/UIList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EventReenrollmentView = ({
  shouldReenroll,
  objectTypeId,
  readOnly,
  setShouldReenroll
}) => {
  return /*#__PURE__*/_jsx(ReenrollmentSelect, {
    shouldReenroll: !!shouldReenroll,
    objectTypeId: objectTypeId,
    readOnly: readOnly,
    setShouldReenroll: setShouldReenroll,
    reenrollDescription: /*#__PURE__*/_jsxs(UIList, {
      styled: true,
      className: "p-left-5",
      children: [/*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.redesign.review.manualReenrollment"
        })
      }), /*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.redesign.review.eventsEnrollmentCritera"
        })
      })]
    })
  });
};
export default EventReenrollmentView;